import { render } from "./idVermontLogo.vue?vue&type=template&id=1de50a45"
import script from "./idVermontLogo.vue?vue&type=script&lang=js"
export * from "./idVermontLogo.vue?vue&type=script&lang=js"

import "./idVermontLogo.vue?vue&type=style&index=0&id=1de50a45&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__